export default __webpack_public_path__ + "static/media/diabetes.dc196563.svg";